export default "__VITE_ASSET__BxUR0qeQ__"